module.exports = __webpack_public_path__ + "static/media/stop black.7ef64d4a.svg";